export enum HomeBusinessAddress {
    homeMailingAddress = 0,
    businessMailingAddress = 1
}